import React, { FormEvent, useState } from 'react';
import { InputField, SelectLightField } from 'forms/fields';
import { Col, Row, Text } from 'mymoria-ui/components';
import DateInputField from 'forms/fields/DateInputField';
import { maritalStatusOptions } from 'forms/options';
import { form } from 'data';
import StyledCard from 'components/StyledCard';
import moment from 'moment';
import config from 'config';

const Deceased = () => {
  const [deathDateHint, setDeathDateHint] = useState<string | undefined>(undefined);
  const hintValidate = (e: FormEvent) => {
    const value = (e.target as HTMLInputElement).value;
    if (moment(value, config.dateFormat.view, true).add('1', 'y').isBefore(moment())) {
      setDeathDateHint('Datum korrekt?');
    } else {
      setDeathDateHint(undefined);
    }
  };

  return (
    <StyledCard title={form.deceased.title}>
      <Row flexWrap="wrap">
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.firstName" label={form.deceased.firstName} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.lastName" label={form.deceased.lastName} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.maidenName" label={form.deceased.maidenName} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <SelectLightField
            name="deceased.maritalStatus"
            label={form.deceased.maritalState}
            options={maritalStatusOptions}
            placeholder={form.deceased.maritalState}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <DateInputField name="deceased.birthDate" label={form.deceased.birthDate} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.birthPlace" label={form.deceased.birthPlace} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <DateInputField
            name="deceased.deathDate"
            label={form.deceased.deathDate}
            hint={deathDateHint}
            onChange={hintValidate}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.deathPlace" label={form.deceased.deathPlace} />
        </Col>
        <Col width={1}>
          <Text>{form.deceased.lastLivingTitle}</Text>
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.street" label={form.deceased.lastLivingStreet} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.houseNr" label={form.deceased.lastLivingHouseNr} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.code" label={form.deceased.lastLivingCode} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="deceased.place" label={form.deceased.lastLivingPlace} />
        </Col>
      </Row>
    </StyledCard>
  );
};

export default Deceased;
